export const TextDivider = ({
  text,
  className = ''
}: {
  text: string | JSX.Element
  className?: string
}) => (
  <div
    className={`grid grid-cols-[1fr,_max-content,_1fr] gap-4 w-full justify-center items-center font-medium text-2xs text-gray-900 ${className}`}
  >
    <div className='border-t-[1px] border-gray-500 w-full' />
    <span className='shrink text-center'>{text}</span>
    <div className='border-t-[1px] border-gray-500 w-full' />
  </div>
)
